module.exports = __webpack_public_path__ + "static/media/PDF_110.51017e67.pdf";